import {Component} from "@angular/core";
import {AppAlertService} from "./app-alert.service";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {AppAlertEditDialogComponent} from "./app-alert-edit-dialog.component";
import {AppAlertGqlModel} from "./app-alert.gql-model";
import {handleErrors} from "../misc/handle-errors.decorator";

@Component({
  templateUrl: "./app-alert-manager.template.pug",
})
export class AppAlertManagerComponent {
  alerts: AppAlertGqlModel[] = [];

  constructor(
    public appAlertService: AppAlertService,
    public dialogService: DialogService,
  ) {
    this.appAlertService.alerts.subscribe((alerts) => {
      this.alerts = alerts;
    });
  }

  @handleErrors()
  async edit(alertToEdit) {
    const {save, alert} = await AppAlertEditDialogComponent.show(this.dialogService, alertToEdit);

    if (!save) return;

    await this.appAlertService.saveGeneralAlert(alert);
  }

  @handleErrors()
  async remove(alertToEdit) {
    await this.appAlertService.removeGeneralAlert(alertToEdit);
  }

  @handleErrors()
  async create() {
    const {save, alert} = await AppAlertEditDialogComponent.show(this.dialogService);

    if (!save) return;

    await this.appAlertService.saveGeneralAlert(alert);
  }
}
